import { images } from '../../assets';
import { GridBackground } from '../GridBackground';

const NutritionSection = () => {
  const benefits = [
    {
      title: 'Planes Personalizados',
      description: 'Diseñados según tus objetivos',
      desktopClasses: 'lg:top-8 lg:-right-4'
    },
    {
      title: 'Seguimiento Continuo',
      description: 'Chat directo para dudas',
      desktopClasses: 'lg:top-1/2 lg:-translate-y-1/2 lg:-left-6'
    },
    {
      title: 'Integración Total',
      description: 'Alineado con tu entrenamiento',
      desktopClasses: 'lg:bottom-8 lg:-right-4'
    }
  ];

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/51935615948?text=Hola,%20me%20interesa%20la%20asesoría%20nutricional', '_blank');
  };

  return (
    <section
      id="servicioNutricion-inner"
      className="relative w-full h-full min-h-screen flex flex-col justify-evenly md:justify-center items-center pt-20 sm:pt-24 md:pt-12 pb-6 sm:pb-8 md:pb-6 px-4 sm:px-6 md:px-8 bg-black overflow-hidden select-none"
    >
      <GridBackground />

      {/* Ambient Background Light sutil */}
      <div className="absolute top-1/4 right-10 w-72 sm:w-96 h-72 sm:h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 left-10 w-60 sm:w-80 h-60 sm:h-80 bg-white/5 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-7xl mx-auto w-full relative z-10 flex flex-col justify-center my-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 sm:gap-6 lg:gap-12 items-center">
          {/* Left Column: Typography & Action */}
          <div className="lg:col-span-6 flex flex-col justify-center text-center lg:text-left">
            <h2 className="anton-font text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white uppercase leading-tight tracking-normal mb-2.5 sm:mb-4">
              PLAN ALIMENTICIO Y NUTRICIÓN <br className="hidden sm:inline" />
              <span className="text-blue-500">BASADO EN TUS OBJETIVOS</span>
            </h2>

            <p className="text-gray-300 text-xs sm:text-sm md:text-base leading-relaxed mb-4 sm:mb-6 max-w-xl mx-auto lg:mx-0 text-center lg:text-justify">
              Alinea tu alimentación con tu entrenamiento. Planes personalizados diseñados para maximizar tus objetivos, ganar masa muscular, mejorar tu rendimiento y salud.
            </p>

            {/* WhatsApp CTA */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-2.5 sm:gap-4">
              <button
                onClick={handleWhatsAppClick}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 sm:px-7 py-3 sm:py-3.5 transition-all duration-300 font-sans font-semibold text-xs sm:text-sm md:text-base shadow-lg shadow-[#25D366]/20 hover:scale-[1.02] active:scale-95 cursor-pointer"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                <span>Consultar</span>
              </button>
              <span className="text-[11px] sm:text-xs text-gray-400 font-medium">¿Listo para empezar? Agenda tu asesoría</span>
            </div>
          </div>

          {/* Right Column: Graphic + Floating (Desktop) / Grid (Mobile) Cards */}
          <div className="lg:col-span-6 flex flex-col items-center">
            {/* Image Container with Floating Cards on Desktop */}
            <div className="relative w-full flex items-center justify-center min-h-[220px] sm:min-h-[270px] lg:min-h-[460px] my-1 sm:my-2">
              {/* Soft ambient back light */}
              <div className="absolute inset-0 m-auto w-40 h-40 sm:w-56 sm:h-56 bg-blue-600/10 rounded-full blur-3xl pointer-events-none" />

              {/* Central Graphic (nutrition_1) with floating animation */}
              <div className="relative z-10 flex items-center justify-center p-1 sm:p-2 h-[220px] min-[380px]:h-[260px] sm:h-[300px] lg:h-[460px] max-h-[35vh] w-auto animate-nutrition-float">
                <img
                  src={images.nutrition_1}
                  alt="Plan Nutricional"
                  className="h-full w-auto max-w-full object-contain drop-shadow-[0_20px_35px_rgba(0,0,0,0.7)] select-none"
                />
              </div>

              {/* Desktop Floating Cards (Only visible on lg: screens) */}
              {benefits.map((b, idx) => (
                <div
                  key={idx}
                  className={`hidden lg:block absolute ${b.desktopClasses} bg-neutral-900/80 backdrop-blur-xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.5)] rounded-2xl p-4 max-w-[210px] z-20 transition-all duration-300 hover:border-neutral-700 hover:scale-105`}
                >
                  <p className="text-xs text-gray-400 font-medium">{b.title}</p>
                  <p className="text-sm font-bold text-white mt-0.5 leading-snug">{b.description}</p>
                </div>
              ))}
            </div>

            {/* Mobile Cards (Visible only on < lg screens) — 3 columnas completas sin iconos y sin truncar */}
            <div className="grid grid-cols-3 gap-2 sm:gap-3 w-full mt-2 sm:mt-4 lg:hidden">
              {benefits.map((b, idx) => (
                <div
                  key={idx}
                  className="bg-neutral-900/85 backdrop-blur-xl border border-neutral-800 shadow-md rounded-xl p-2.5 sm:p-3 text-center transition-all duration-300 flex flex-col items-center justify-center hover:border-neutral-700 min-h-[64px]"
                >
                  <p className="text-[11px] sm:text-xs font-bold text-white leading-tight">
                    {b.title}
                  </p>
                  <p className="text-[10px] sm:text-[11px] text-gray-400 mt-1 sm:mt-1.5 leading-snug">
                    {b.description}
                  </p>
                </div>
              ))}
            </div>

            {/* Mobile Bottom Value Bar — Rellena el espacio inferior con información útil y estética limpia */}
            <div className="w-full max-w-lg mx-auto mt-3 sm:mt-4 pt-2.5 border-t border-neutral-800/80 flex items-center justify-center gap-3 sm:gap-6 text-center text-[10px] min-[380px]:text-[11px] sm:text-xs text-neutral-400 font-medium lg:hidden">
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                Evaluación Corporal
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                Ajuste Periódico
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                100% Personalizado
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NutritionSection;
